import { Spacer } from "@nextui-org/react";

import { LocalizedLink } from "@/components";
import { Col, Row, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

import { CreatorCardProps } from "./types";

const YELLOW_GRADIENT = "bg-[linear-gradient(180deg,#FFDD6D_0%,#998346_100%)] [-webkit-text-fill-color:transparent] bg-clip-text";
const SCORE_DIVISOR = 1000;

const getMovementType = (movement: number): string => {
  if (movement === 0) return "";
  return movement > 0 ? "!text-[#2B8761]" : "!text-[#FC6666]";
};

const formatScoreInThousands = (score: number): string => `${(score / SCORE_DIVISOR).toFixed(1)}k`;

const formatMovement = (movement: number): string => (movement > 0 ? `+${movement}` : String(movement));

export default function CreatorCard(props: CreatorCardProps) {
  const { data: creatordata, className = "" } = props;

  const { creator_username = "", number_of_characters = 0, score = 0, rank = 0, movement = 0, avatar_url = "" } = creatordata;
  const formattedScore = formatScoreInThousands(score);
  const formattedMovement = formatMovement(movement);
  const formattedRank = `#${rank}`;
  const creatorHandle = `@${creator_username}`;

  return (
    <Col className={"w-max text-center items-center relative " + className}>
      <div className="rounded-full absolute right-8 top-4 z-20 text-white bg-[#353535] w-[30px] h-[30px] grid place-items-center pb-0.5">
        <Text b type={YELLOW_GRADIENT}>
          {formattedRank}
        </Text>
      </div>

      <div
        className={
          "[clip-path:polygon(25%_0%,75%_0%,100%_50%,75%_100%,25%_100%,0%_50%)] size-[130px] rotate-90 flex items-center justify-center p-3 relative " +
          (rank === 1 ? "bg-[linear-gradient(90deg,#FFDD6D_0%,#998541_100%)]" : "bg-[linear-gradient(90deg,#353535_0%,#D9D9D9_100%)]")
        }
      >
        <div className="[clip-path:polygon(25%_0%,75%_0%,100%_50%,75%_100%,25%_100%,0%_50%)] bg-white dark:bg-black absolute top-1 left-1 right-1 bottom-1"></div>
        {avatar_url ? (
          <img
            loading="lazy"
            src={avatar_url}
            alt="creator avatar"
            className={
              "[clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)] -rotate-[90deg] h-full w-full object-cover object-center"
            }
          />
        ) : null}
      </div>
      <Spacer y={3} />
      <LocalizedLink to={`/creator/${creator_username}`} aria-label="creator">
        <Text>{creatorHandle}</Text>
      </LocalizedLink>
      <Spacer y={5} />
      <Row className="whitespace-nowrap dark:bg-[#323942] shadow-[0px_4px_16.8px_3px_#32394220] dark:shadow-[0px_4px_16.8px_3px_#323942] p-3 px-5 rounded-2xl *:gap-2 w-[200px]">
        <Col className="text-start">
          <Trans i18nKey="leaderboard:creatorCard.numBots" />
          <Trans i18nKey="leaderboard:creatorCard.score" />
          <Trans i18nKey="leaderboard:creatorCard.mmRank" />
        </Col>
        <Col className="text-end">
          <Text b type={YELLOW_GRADIENT}>
            {number_of_characters}
          </Text>
          <Text b type={YELLOW_GRADIENT}>
            {formattedScore}
          </Text>
          <Text b type={getMovementType(movement)}>
            {formattedMovement}
          </Text>
        </Col>
      </Row>
    </Col>
  );
}
